import { HttpErrorResponse } from '@angular/common/http';
import { httpErrorToApiError } from '@nano/core/api';
import { OauthErrorMessage } from '@nano/core/oauth';
import { OauthErrorCode } from '@nano/core/oauth';

export function isExpectedTfaError(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) return false;
  if (error.status !== 403) return false;

  const oauthError = error.error as OauthErrorMessage;
  return oauthError?.category === '2fa' && oauthError?.key === '2fa.required';
}

export function isExpectedUnauthorizedError(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
    return false;
  }

  const oauthErrorCode = httpErrorToApiError(error)?.code as OauthErrorCode | undefined;
  return oauthErrorCode === OauthErrorCode.AP_7;
}

export function isCrossOriginFrameSecurityError(error: unknown): boolean {
  return error instanceof DOMException && error.code === 18 && typeof error.message === 'string' && error.message.toLowerCase().includes('cross-origin frame');
}

export function isXhrBlobResponseTextError(error: unknown): boolean {
  return (
    error instanceof DOMException &&
    error.code === 11 &&
    typeof error.message === 'string' &&
    error.message.includes('responseText') &&
    error.message.includes('responseType') &&
    error.message.includes('blob')
  );
}

export function isDynamicIconLoadError(error: unknown): boolean {
  return (
    error instanceof Error &&
    typeof error.message === 'string' &&
    error.message.includes('@ant-design/icons-angular') &&
    error.message.includes('does not exist or is not registered')
  );
}

export function shouldDropSentryError(error: unknown): boolean {
  return (
    isExpectedTfaError(error) ||
    isExpectedUnauthorizedError(error) ||
    isCrossOriginFrameSecurityError(error) ||
    isXhrBlobResponseTextError(error) ||
    isDynamicIconLoadError(error)
  );
}
